import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import MainContainer from "../GlobalComponents/MainContainer/MainContainer";
import { NavContext } from "../App";
import styles from "./dashboard.module.css";

export function DashboardLayout(props) {
  const navigate = useNavigate();
  const context = useContext(NavContext);

  useEffect(() => {
    if (!context.logged) {
      navigate("/");
    }
  }, [context.logged, navigate]);

  return (
    <div className={styles.dashboardWrapper}>
      <main className={styles.mainContent}>
        <MainContainer />
      </main>
    </div>
  );
}

DashboardLayout.displayName = "/src/layouts/dashbord.jsx";

export default DashboardLayout;